import { Div } from '@kizi/core-components';
import { Radio, RadioProps } from '@kizi/shared-components';
import React from 'react';
import { isMobile } from '../../utils/global';

export interface HomeMainCoverageBlockProps {
  label: React.ReactElement;
  radio?: RadioProps;
  style?: any;
  buttonMaxWidth?: string;
  direction?: 'horizontal' | 'vertical';
  customStyles?: any;
}

export const TileRadioButton: React.VFC<HomeMainCoverageBlockProps> = ({
  label,
  radio,
  style,
  buttonMaxWidth,
  direction = 'vertical',
  customStyles,
}) => {
  const handleChange = React.useCallback(() => {
    radio?.onChange?.({
      target: {
        name: radio.name as string,
        value: radio.value as string,
        checked: !radio.checked,
      },
    } as React.ChangeEvent<any>);
    radio?.onClick?.({
      target: {
        name: radio.name as string,
        value: radio.value as string,
        checked: !radio.checked,
      },
    } as any);
  }, [radio]);

  const handleClick = React.useCallback<
    React.MouseEventHandler<HTMLDivElement>
  >(
    (event) => {
      if (event.target instanceof HTMLInputElement) {
        return;
      }
      handleChange();
    },
    [handleChange],
  );

  const cardBorderColor = radio?.checked ? 'main.1' : 'transparent';
  const cardBackroundColor = cardBorderColor;
  const radioBorderColor = radio?.checked ? 'white' : null;
  const indicatorCss = {
    backgroundColor: radio?.checked ? 'white!important' : null,
  };
  const css = radio?.checked
    ? { '&:hover': { backgroundColor: 'main.1', borderColor: 'white' } }
    : null;
  const cursor = radio ? 'pointer' : '';

  return (
    <>
      {direction === 'horizontal' ? (
        <Div
          position="relative"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          variant="radioTileHorizontal"
          borderWidth={2}
          borderStyle="solid"
          alignItems="center"
          style={{
            ...style,
            boxSizing: 'border-box',
            cursor: cursor,
          }}
          borderColor={cardBorderColor}
          onClick={handleClick}
          width={'100%'}
          height={50}
          maxWidth={isMobile() ? null : buttonMaxWidth}
          css={{
            ...customStyles,
            backgroundColor: cardBackroundColor,
          }}
        >
          <Div display="flex" alignItems="center" width={22}>
            <Radio
              id={radio?.name}
              variant="main"
              {...radio}
              mx={0}
              width={20}
              height={20}
              containerProps={{
                ...radio?.containerProps,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row-reverse',
                justifyContent: 'center',
              }}
              label=""
              onChange={handleChange}
              borderColor={radioBorderColor}
              borderWidth="1px"
              indicatorCss={indicatorCss}
              css={css}
            />
          </Div>
          <Div
            flex={10}
            flexDirection="column"
            marginLeft={3}
            variant={radio?.checked ? 'labelChecked' : ''}
          >
            {label}
          </Div>
        </Div>
      ) : (
        <Div
          position="relative"
          display="flex"
          flexDirection="column"
          variant="radioTileVertical"
          justifyContent="space-between"
          borderWidth={2}
          borderStyle="solid"
          background={cardBackroundColor}
          borderColor={cardBorderColor}
          style={{ boxSizing: 'border-box', cursor: cursor }}
          onClick={handleClick}
        >
          <Div flex={1} variant={radio?.checked ? 'labelChecked' : ''}>
            {label}
          </Div>
          <Div>
            <Div display="flex" flexDirection="column" alignItems="center">
              <Radio
                id={radio?.name}
                variant="main"
                {...radio}
                mx={0}
                width={20}
                height={20}
                containerProps={{
                  ...radio?.containerProps,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row-reverse',
                  justifyContent: ['center', null, 'flex-end'],
                  pt: 3,
                }}
                label=""
                onChange={handleChange}
                borderColor={radioBorderColor}
                borderWidth="1px"
                indicatorCss={indicatorCss}
                css={css}
              />
            </Div>
          </Div>
        </Div>
      )}
    </>
  );
};
